import React, { useEffect, useState } from "react";
import { getAvatarsFromStorage } from "../../../services/fileServices/FileService";
import Avatar from "../../../interfaces/avatar/Avatar";
import { useAuth } from "../../../firebase/AuthProvider";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { getUserInfoByUserId } from "../../../services/userServices/UserInfoService";
import UserInfo from "../../../interfaces/UserInfo";
import { toTitleCase } from "../../../utilities/stringUtils";
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import AvatarImage from "../../ui/Avatar/AvatarImage";
import editicon from "../../../assets/images/EDIT.png";
import FrameProfile from "../../../assets/images/FrameProfile.png";
import UserAvatar from "../calendar/UserAvatar";



const UserProfile: React.FC = () => {
  const { currentUser } = useAuth();
  const { userId } = useParams();

  const navigate = useNavigate();
  const location = useLocation();

  const [avatars, setAvatars] = useState<Avatar[] | null>([]);
  const [user, setUser] = useState<UserInfo>();

  const activeNavItem = React.useMemo(() => {
    if (location.pathname.endsWith("/tasks")) return "tasks";
    if (location.pathname.endsWith("/documents")) return "documents";
    if (location.pathname.endsWith("/files")) return "files";
    if (location.pathname.endsWith("/activities")) return "activities";
    if (location.pathname.endsWith("/reports")) return "reports";
    return "overview";
  }, [location.pathname]);

  useEffect(() => {
    if (currentUser && userId) {
      const fetchData = async () => {
        const authToken = await currentUser.getIdToken();
        const data = await getUserInfoByUserId(userId, authToken);
        if (data) {
          setUser(data);
        }
      };

      fetchData();
    }
  }, [userId]);



  useEffect(() => {
    const storedAvatars = getAvatarsFromStorage();
    setAvatars(storedAvatars);
  }, []);

  const findAvatarById = (userId: string): string | null => {
    const avatarObj = avatars?.find((avatar) => avatar.id === userId);
    return avatarObj ? `data:image/png;base64,${avatarObj.avatar}` : null;
  };

  const avatarUrl = findAvatarById(userId || "");

  const handleTabSelect = (key: string | null) => {
    if (!key || !userId) return;
    const routeMap: Record<string, string> = {
      activities: 'activities',
      tasks: 'tasks',
      documents: 'documents',
      files: 'files',
      reports: 'reports',
      reviews: 'reports'
    };

    navigate(`/profile/user/${userId}/${routeMap[key]}`);
  };

  const InfoRow = ({ label, value, border }: { label: any; value: any; border?: boolean; }) => (
    <div className={`space-y-1 pb-2 ${border ? "border-b border-[#0000000D]" : ""}`}>
      <p className="text-[#6E6E73] m-0 mb-2 text-base">{label}</p>
      <p className="text-base text-[#1D1D1F] m-0">{value}</p>
    </div>
  );


  return (
    <>

      <div className="bg-white rounded-[10px] p-[20px] w-full">
        <div className="flex flex-col gap-6 w-full lg:flex-row lg:flex-nowrap " style={{ alignItems: "start" }}>
          <div className="bg-white border rounded-xl p-6 bg-no-repeat bg-[length:100%_125px] bg-top w-full lg:w-[40%] xl:w-[30%] 2xl:w-[25%] shrink"
            style={{ backgroundImage: `url(${FrameProfile})` }}>
            <div className="flex flex-col items-center ">
              <div className="profile_info_upload">
                <UserAvatar
                  userId={user?.id || ""}           
                  displayName={`${user?.firstName} ${user?.lastName}`}
                  className="w-20 h-20 lg:h-28 lg:w-28"
                  color="#C7AFDB"
                />
              </div>
              <h2 className="text-base font-semibold mt-2 mb-0">{user?.firstName} {user?.lastName}</h2>
              <p className="text-base min-w-[150px] text-center text-[#747474] m-0 mt-1 bg-[#F9F6FF] rounded-full px-4 py-1">{user && user?.roles.length > 0
                ? toTitleCase(
                  user.roles.reduce((maxRole, currentRole) =>
                    currentRole.id > maxRole.id ? currentRole : maxRole
                  ).name
                )
                : "No roles available"}</p>
            </div>

            <div className="mt-16 space-y-4 text-sm">
              <InfoRow label="Email" border value={user?.email || "-"} />
              <InfoRow label="Agency Name" border value={toTitleCase(user?.organization.name || "")} />

              <InfoRow
                label="Region"
                value={"Region 2"}
              />

            </div>
          </div>
          <div className="w-full lg:w-[60%] xl:w-[70%] 2xl:w-[75%] overflow-auto">
            {/* Tabs Header */}
            <div className="bg-[#F4F4F4] px-2 py-1 rounded-md">
              <div className="flex flex-wrap justify-evenly gap-2">
                {[
                  { key: "files", label: "Employee Files" },
                  { key: "tasks", label: "Recent Task" },
                  { key: "activities", label: "Activity" },
                  { key: "reviews", label: "Reviews" },
                ].map((tab) => {
                  const isActive = activeNavItem === tab.key;

                  return (
                    <button
                      key={tab.key}
                      onClick={() => handleTabSelect(tab.key)}
                      className={`flex-1 min-w-[140px] py-2 flex items-center justify-center rounded-[6px] font-poppins font-medium text-[11px] xl:text-[14px] leading-[20px] transition-all ${isActive
                        ? "bg-white text-[#7E57C2] border border-black/25 shadow-[1px_1px_4px_rgba(0,0,0,0.25)]"
                        : "text-black hover:bg-white"
                        }`}
                    >
                      {tab.label}
                    </button>
                  );
                })}
              </div>
            </div>
            <div className="mt-4">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserProfile;
